var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    viewBox: "0 0 6 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.27688 2.42133V4.02433H0.102051V5.98433H1.27688V11.8095H3.68838V5.98491H5.30713C5.30713 5.98491 5.4588 5.04516 5.5323 4.01733H3.6983V2.67683C3.6983 2.47675 3.9608 2.20725 4.22097 2.20725H5.5358V0.166748H3.74847C1.2168 0.166748 1.27688 2.1285 1.27688 2.42133Z",
    fill: "#F6AF3E",
    fillOpacity: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a832875f654e040db7f1b682d7b1062c.svg";
export { ForwardRef as ReactComponent };